import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 残存償却適用 */
enum ResidualDepreciationApplication {
  execute = '1',
  doNotExecute = '2',
}

const nameConfig = {
  execute: new Map([[Locale.ja, '行う']]),
  doNotExecute: new Map([[Locale.ja, '行わない']]),
};

const toEnum = rawValueToEnum(ResidualDepreciationApplication, ResidualDepreciationApplication.doNotExecute);
const toDisplay = enumToName(ResidualDepreciationApplication, nameConfig);
const toDisplayWithPrefix = enumToName(ResidualDepreciationApplication, nameConfig, {
  prefix: true,
});

export const residualDepreciationApplication = {
  enum: ResidualDepreciationApplication,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ResidualDepreciationApplication };
